import type { ActionSpec } from '@/features/hr/parts'
import { cubeWallClock } from '@/lib/hr'
import type { HareketRow, IzinRow } from '@/services/cube/hr'

/** Hareket satırının aksiyonları: karar varsa yalnız kaldırma, yoksa yoksay / elle girildi. */
export function hareketActions(row: HareketRow): ActionSpec[] {
  const actions: ActionSpec[] = [
    { type: 'hareket_tekrar_gonder' },
    { type: 'hareket_passgage_guncel_al' },
  ]
  if (row.karar) actions.push({ type: 'karar_kaldir' })
  else {
    actions.push({ type: 'hareket_yoksay', needsReason: true })
    actions.push({ type: 'hareket_elle_girildi', needsReason: true })
  }
  return actions
}

/** İ1 yalnız aynı gün içinde kalan saatlik izin (İ2 kapsam dışı). */
export function hourFixable(leave: Pick<IzinRow, 'saatlik' | 'baslangic' | 'bitis'>): boolean {
  const start = cubeWallClock(leave.baslangic)
  const end = cubeWallClock(leave.bitis)
  return leave.saatlik === true && !!start && !!end && start.date === end.date
}
